import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Directive, HostListener } from '@angular/core';
declare var $: any;

@Directive({
  selector: '[appWindowHeight]',
})
export class WindowHeightDirective {
  passHeight: number;
  @Output() windowWidth: EventEmitter<any> = new EventEmitter();

  errorHeightValue: any;
  @Output() defaultHeights: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.setWindowHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setWindowHeight();
  }
  setWindowHeight() {
    var windowHeight = window.innerHeight;
    this.windowWidth.emit(window.innerWidth);
    var headerHeight = $('#headerItem').outerHeight(true);
    var footerHeight = $('#footerItem').outerHeight(true);
    if (windowHeight <= 736) {
      this.defaultHeights.emit(windowHeight - headerHeight - footerHeight);
    }
    if (windowHeight > 736 && windowHeight < 999) {
      this.defaultHeights.emit(windowHeight - headerHeight - footerHeight);
    }
    if (windowHeight > 1000) {
      this.defaultHeights.emit(windowHeight - headerHeight - footerHeight);
    }
  }
}
